import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { baseUrl } from '../../config';
import logo from '../../images/logo.png';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  // Check login status on mount and when localStorage changes
  useEffect(() => {
    checkLoginStatus();

    // Listen for storage changes (if user logs in/out in another tab)
    const handleStorageChange = () => {
      checkLoginStatus();
    };
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const checkLoginStatus = () => {
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    const authenticated = localStorage.getItem('authenticated');
    
    if (storedUser && token && authenticated === 'true') {
      try {
        const user = JSON.parse(storedUser);
        setIsLoggedIn(true);
        setUserName(user.name || user.email || 'User');
      } catch (e) {
        setIsLoggedIn(false);
        setUserName('');
      }
    } else {
      setIsLoggedIn(false);
      setUserName('');
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    // Clear all auth data
    localStorage.removeItem('authenticated');
    localStorage.removeItem('user');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('rememberMe');
    
    setIsLoggedIn(false);
    setUserName('');
    // Navigate to logout page
    navigate(baseUrl + '/logout');
  };

  return (
    <React.StrictMode>
      <header id="header_1">
        <div className="header-top-bar d-none d-md-block">
          <div className="container-fluid">
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-xl-8 col-lg-12 col-md-12 col-12 header-contact-layout1">
                <ul>
                  <li>
                    <i className="fas fa-phone" />
                    Call: +91 9997776991
                  </li>
                </ul>
              </div>
              <div className="col-xl-4 d-none d-xl-block header-contact-layout1">
                <ul style={{ justifyContent: 'end' }}>
                  <li>
                    <i className="far fa-envelope-open" />
                    info@predyxiq.com
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="header-menu-area header-menu-layout1">
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg navbar-light">
              <div className="row no-gutters d-flex align-items-center w-100">
                <div className="col-lg-2 col-md-2 col-6 logo-area-layout1">
                  <Link to={baseUrl + '/'} className="temp-logo">
                    <img
                      src={logo}
                      alt="AdminLTE Logo"
                      className=""
                      style={{ opacity: 0.8 }}
                    />
                  </Link>
                </div>

                {/* Mobile Toggle Button */}
                <div className="col-6 d-lg-none d-flex justify-content-end">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleMenu}
                    aria-controls="navbarNav"
                    aria-expanded={isMenuOpen}
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </div>

                {/* Navigation Menu */}
                <div className={`col-lg-8 col-md-8 ${isMenuOpen ? '' : 'd-none d-lg-block'}`}>
                  <div className="template-main-menu">
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <Link to={baseUrl + '/'} onClick={() => window.scrollTo(0, 0)} className="nav-link">Home</Link>
                      </li>
                      <li className="nav-item">
                        <Link to={baseUrl + '/clinical-intelligence'} onClick={() => window.scrollTo(0, 0)} className="nav-link">Clinical Intelligence</Link>
                      </li>
                      <li className="nav-item">
                        <Link to={baseUrl + '/platform'} onClick={() => window.scrollTo(0, 0)} className="nav-link">Platform</Link>
                      </li>
                      <li className="nav-item">
                        <Link to={baseUrl + '/science-of-clinical-intelligence'} onClick={() => window.scrollTo(0, 0)} className="nav-link">Science</Link>
                      </li>
                      <li className="nav-item">
                        <Link to={baseUrl + '/predyxiq-services'} onClick={() => window.scrollTo(0, 0)} className="nav-link">Who Predyx Serves</Link>
                      </li>
                      <li className="nav-item">
                        <Link to={baseUrl + '/predyxiq-quick'} onClick={() => window.scrollTo(0, 0)} className="nav-link">PredyxIQ Quick</Link>
                      </li>
                      <li className="nav-item">
                        <Link to={baseUrl + '/about'} onClick={() => window.scrollTo(0, 0)} className="nav-link">About</Link>
                      </li>
                    </ul>
                    
                    {/* Mobile Action Buttons - Only visible on mobile */}
                    <ul className="desk-hide d-flex" style={{ listStyle: 'none', margin: '10px 0 0 0', padding: 0 }}>
                      {!isLoggedIn ? (
                        <>
                          <li>
                            <Link to={baseUrl + '/contact'} onClick={() => window.scrollTo(0, 0)} className="action-items-primary-btn">
                              Request a Demo <i className="fas fa-chevron-right" />
                            </Link>
                          </li>
                          <li>
                            <Link to={baseUrl + '/login'} onClick={() => window.scrollTo(0, 0)} className="action-items-primary-btn">
                              Login <i className="fas fa-chevron-right" />
                            </Link>
                          </li>
                        </>
                      ) : (
                        <>
                          <li>
                            <Link to={baseUrl + '/user/dashboard'} onClick={() => window.scrollTo(0, 0)} className="action-items-primary-btn">
                              <i className="fas fa-tachometer-alt"></i> Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link 
                              to={baseUrl + '/logout'} 
                              className="action-items-primary-btn"
                              style={{ 
                                background: '#dc3545',
                                color: '#fff',
                                border: '1px solid #dc3545',
                                borderRadius: '5px',
                                padding: '8px 15px',
                                textDecoration: 'none',
                                display: 'inline-block'
                              }}
                            >
                              <i className="fas fa-sign-out-alt"></i> Logout
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>

                {/* Desktop Action Buttons */}
                <div className="col-lg-2 col-md-2 d-none d-lg-block">
                  <div className="header-action-items-layout1">
                    <ul className="d-flex" style={{ listStyle: 'none', margin: 0, padding: 0, alignItems: 'center' }}>
                      {!isLoggedIn ? (
                        <>
                          <li>
                            <Link to={baseUrl + '/contact'} onClick={() => window.scrollTo(0, 0)} className="action-items-primary-btn">
                              Request a Demo <i className="fas fa-chevron-right" />
                            </Link>
                          </li>
                          <li>
                            <Link to={baseUrl + '/login'} onClick={() => window.scrollTo(0, 0)} className="action-items-primary-btn">
                              Login <i className="fas fa-chevron-right" />
                            </Link>
                          </li>
                        </>
                      ) : (
                        <>
                          <li style={{ marginRight: '10px' }}>
                            <span style={{ color: '#fff', fontSize: '14px' }}>
                              <i className="fas fa-user-circle"></i> {userName}
                            </span>
                          </li>
                          <li>
                            <Link 
                              to={baseUrl + '/user/dashboard'} 
                              onClick={() => window.scrollTo(0, 0)} 
                              className="action-items-primary-btn"
                              style={{
                                background: '#007bff',
                                color: '#fff',
                                border: '1px solid #007bff',
                                borderRadius: '5px',
                                padding: '10px 15px',
                                textDecoration: 'none',
                                display: 'inline-block'
                              }}
                            >
                               Dashboard
                            </Link>
                          </li>
                          <li>
                            <Link 
                              to={baseUrl + '/logout'} 
                              className="btn btn-danger"
                              style={{
                                background: '#dc3545',
                                color: '#fff',
                                border: '1px solid #dc3545',
                                borderRadius: '5px',
                                padding: '8px 15px',
                                textDecoration: 'none',
                                display: 'inline-block',
                                marginLeft: '5px'
                              }}
                            >
                              <i className="fas fa-sign-out-alt"></i> Logout
                            </Link>
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </React.StrictMode>
  );
}

export default Header;
